import type { CSSProperties } from "react";

interface SectionContainerProps {
  children: React.ReactNode;
  cssProperties?: CSSProperties;
}
export const SectionContainer = ({
  cssProperties,
  children,
}: SectionContainerProps) => <div style={{ ...cssProperties }}>{children}</div>;
